import SodRiskPriorityChip from './SodRiskPriorityChip';

export default SodRiskPriorityChip;
